import gsap from "../../../../_snowpack/pkg/gsap.js";
import Events from "./Events.js";

class Raf {
	constructor() {
		this.init();
	}

	tick() {
		Events.emit("tick");
	}

	on() {
		gsap.ticker.add(this.tick.bind(this));
	}

	init() {
		this.on();
	}
}

export default new Raf();
